import { render } from "./CardDetails.vue?vue&type=template&id=43fad908&scoped=true"
import script from "./CardDetails.vue?vue&type=script&lang=js"
export * from "./CardDetails.vue?vue&type=script&lang=js"

import "./CardDetails.vue?vue&type=style&index=0&id=43fad908&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fad908"]])

export default __exports__